import * as Joi from "joi";
import i18n from "i18n/index";

export const FREQUENTLY_ASKED_QUESTIONS_SCHEMA = Joi.object({
    question_ar: Joi.string()
        .required()
        .empty('')
        .label("السؤال بالعربى")
        .messages({ 'any.required': `{#label} ${i18n.t("validationErrors.isRequired")}` }),
    answer_ar: Joi.string()
        .required()
        .empty('')
        .label("الإجابة بالعربى")
        .messages({ 'any.required': `{#label} ${i18n.t("validationErrors.isRequired")}` }),
    question_en: Joi.string()
        .required()
        .empty('')
        .label("The question in English")
        .messages({ 'any.required': `{#label} ${i18n.t("validationErrors.isRequired")}` }),
    answer_en: Joi.string()
        .required()
        .empty('')
        .label("The answer in English")
        .messages({ 'any.required': `{#label} ${i18n.t("validationErrors.isRequired")}` }),
})